module.exports = __webpack_public_path__ + "static/akebia-logo-green-8aea013c7afb298f56614b26de76e582.png";